import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { Providers } from './providers';
import { queryClient } from './providers/queryClient';
import { ToastStackProvider } from '@/true-fsd/shared/ui/Toast';
import { AppRouter } from './routers';

function App() {
  return (
    <>
      <ToastStackProvider>
        <Providers queryClient={queryClient}>
          <AppRouter />
        </Providers>
      </ToastStackProvider>
      {createPortal(<ToastContainer />, document.body)}
    </>
  );
}

export default App;
